import { Courses } from '../../services';
import { createRestSlices, createGenericSlice, applyReducers } from './rest';

const {
    initialState,
    createReducer,
    startCreateReducer,
    getReducer,
    listReducer,
    updateReducer,
    deleteReducer,
    createAction,
    startCreateAction,
    getAction,
    listAction,
    updateAction,
    deleteAction,
} = createRestSlices(Courses);

// start rollcall generic slice
const { reducer: startRollcallReducer, action: startRollcallAction } = createGenericSlice(Courses, {
    name: 'startRollcall',
    action: (course) => Courses.startRollcall(course),
    onSuccess: (state, action) => ({ ...state, course: action.course }),
    onError: (state, error) => ({ ...state }),
});

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        startRollcallReducer,
    ]);
}

/* Export CRUD actions */
export const startCreateCourse = startCreateAction;
export const createCourse      = createAction;
export const loadCourse        = getAction;
export const loadCourses       = listAction;
export const updateCourse      = updateAction;
export const deleteCourse      = deleteAction;
export const startRollcall     = startRollcallAction;
